import { addWeeks, addMonths, format } from "date-fns";
import { sv } from "date-fns/locale";
import type { GroupScheduleDates } from "@/types/groups";

export const calculateGroupDates = (firstPossibleDate: Date): GroupScheduleDates => {
  const interventionStart = firstPossibleDate;
  const interventionEnd = addWeeks(firstPossibleDate, 4);
  
  const themeStart = firstPossibleDate;
  const controlInterventionStart = addWeeks(firstPossibleDate, 4);
  const controlInterventionEnd = addWeeks(controlInterventionStart, 4);
  
  return {
    // Intervention scenario: starts immediately, ends 4 weeks later
    interventionStart,
    interventionEnd,
    
    // Control scenario: theme meeting first, then intervention after 4 weeks
    themeStart,
    controlInterventionStart,
    controlInterventionEnd,
    
    // Follow-up SMS: 6 months after intervention start
    followUpSms: addMonths(interventionStart, 6),
    controlFollowUpSms: addMonths(controlInterventionStart, 6),
  };
};

export const formatSwedishDate = (date: Date): string => {
  return format(date, "d MMMM yyyy", { locale: sv });
};

export const getGroupStatusLabel = (group: {
  first_possible_date: string | null;
  schedule_accepted_at: string | null;
  assigned_group: string | null;
}): { label: string; variant: "default" | "secondary" | "destructive" | "outline" } => {
  if (!group.first_possible_date) {
    return { label: "Väntar på datum", variant: "outline" };
  }
  
  if (!group.schedule_accepted_at) {
    return { label: "Väntar på bekräftelse", variant: "secondary" };
  }
  
  return {
    label: group.assigned_group === "intervention" ? "Intervention" : "Kontroll",
    variant: group.assigned_group === "intervention" ? "default" : "secondary",
  };
};
